import './screen-reader.scss';

type HeaderTag = 'h1' | 'h2' | 'h3';

interface ScreenReaderElementProps {
    text?: string;
    tagType?: HeaderTag | 'span';
    role?: 'alert';
}

export const ScreenReaderElement = ({ text, tagType = 'span', ...props }: ScreenReaderElementProps) => {
    const Tag = tagType;

    return (
        <Tag className="sr-only" {...props}>
            {text}
        </Tag>
    );
};
